var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemperatuur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35.3 35.3",
    style: {
      enableBackground: "new 0 0 35.3 35.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#33ADA3;stroke-width:1.35;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#F28F39;stroke-width:1.35;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#E8553F;stroke-width:1.35;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#E8553F;}\n\t.st4{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.4,18.2V6.5c0-2.3-1.9-4.1-4.1-4.1s-4.1,1.9-4.1,4.1v11.7c-2.3,1.4-3.8,3.9-3.8,6.7c0,4.4,3.5,7.9,7.9,7.9 s7.9-3.5,7.9-7.9C23.1,22.1,21.6,19.6,19.4,18.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 15.2,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.2,
    y1: 8.3,
    x2: 15.2,
    y2: 20.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 28.1,
    y1: 17.1,
    x2: 23.1,
    y2: 17.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 28.1,
    y1: 13,
    x2: 23.1,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 28.1,
    y1: 9,
    x2: 23.1,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 28.1,
    y1: 5,
    x2: 23.1,
    y2: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatuur);
export default __webpack_public_path__ + "static/media/temperatuur.3b7857e271eee73ae3da326a00a6d462.svg";
export { ForwardRef as ReactComponent };